import { Bell } from "lucide-react";

interface HeaderNotificationsProps {
  unreadCount?: number;
  onOpen?: () => void;
}

export default function HeaderNotifications({ unreadCount = 0, onOpen }: HeaderNotificationsProps) {
  return (
    <button
      onClick={onOpen}
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-xl text-[#18365E] bg-white/60 ring-1 ring-slate-200 hover:ring-[#18365E] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#18365E] transition-all"
      aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread` : ""}`}
    >
      <Bell className="w-[18px] h-[18px]" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#FF6E4C] px-1 text-[10px] font-bold text-white">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
}
